export enum OngoingABTests {
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page",
    DSA_RATING_SORT = "algorytmic_listing_sort"
}
export enum OngoingABTests {
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page",
    DSA_RATING_SORT = "algorytmic_listing_sort"
}
